import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-cyan-50 flex items-center justify-center px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-8">
          <h1 className="text-5xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Thank You for Connecting
          </h1>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-3xl border border-teal-200/50 p-8 md:p-12 shadow-xl">
          <div className="max-w-2xl mx-auto">
            <p className="text-xl md:text-lg text-gray-700 leading-relaxed mb-5">
              I've personally received your message. Thank you for taking this important first step on your wellness journey.
            </p>

            <p className="text-xl md:text-lg text-gray-700 leading-relaxed mb-7">
              I'm excited to talk with you one-on-one about your goals.
            </p>

            <p className="text-xl md:text-lg text-gray-700 leading-relaxed mb-10">
              I'll be reviewing your information and will reach out to you directly within 24 hours to schedule our conversation.
            </p>

            <div className="text-right mb-10">
              <p className="text-2xl md:text-xl font-semibold text-teal-600 mb-4">
                Talk soon,
              </p>
              <p className="text-2xl md:text-2xl font-bold text-teal-700 mt-1">
                Andrea Villalobos
              </p>
            </div>

            <Link
              to="/main"
              className="inline-flex items-center justify-center rounded-2xl bg-gradient-to-r from-teal-500 to-cyan-400 px-6 py-3 text-base font-semibold text-white shadow-lg"
            >
              Back to the site
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
